module.exports = __webpack_public_path__ + "static/media/imgg.af95a316.png";